/**
 * Tiles left in the bag. Carries `data-bag-counter`: newly drawn rack tiles
 * fly in from here (components/Rack.tsx).
 */
import clsx from 'clsx';
import { AnimatedNumber } from './AnimatedNumber';
import { IconBag } from './Icons';
import './BagCounter.css';

export function BagCounter({ count, variant = 'card' }: { count: number; variant?: 'card' | 'chip' }) {
  return (
    <span
      className={clsx('bag', `bag--${variant}`, count === 0 && 'is-empty')}
      data-bag-counter=""
      title={variant === 'chip' ? `${count} ${count === 1 ? 'tile' : 'tiles'} left in the bag` : undefined}
    >
      <span className="bag__icon" aria-hidden="true">
        <IconBag />
      </span>
      <span className="bag__count tabular" aria-hidden="true">
        <AnimatedNumber value={count} />
      </span>
      <span className="sr-only">
        {count} {count === 1 ? 'tile' : 'tiles'} left in the bag
      </span>
      {variant === 'card' && (
        <span className="bag__label" aria-hidden="true">
          {count === 0 ? 'bag is empty' : 'in the bag'}
        </span>
      )}
    </span>
  );
}
